import styled, { css } from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";

import { smallScreen } from "../../../../shared/constants/screenSizes";
import { RADIO_INPUT_GROUP_THEMES } from "./radioInputGroupThemes";

const theme = props => props.theme.theme;

const withThemeStyles = themeObj => props => themeObj?.[theme(props)];

export const CustomOptionContainer = styled.div``;

export const RadioInputGroupContainer = styled.div``;

export const RadioInputUnitContainer = styled.div`
  position: relative;
`;

const radioInputLabelThemeStyles = {
  [RADIO_INPUT_GROUP_THEMES.button]: css`
    border: 1px solid ${colors.foxGrey};
    display: block;
    margin: 0 0 20px;
    padding: 8px;
    position: relative;
    text-align: center;

    @media screen and (max-width: ${smallScreen}px) {
      font-size: 16px;
    }
  `
};

export const RadioInputLabel = styled(Text).attrs({
  as: "label",
  type: "sm"
})`
  ${withThemeStyles(radioInputLabelThemeStyles)}
`;

const radioInputThemeStyles = {
  [RADIO_INPUT_GROUP_THEMES.button]: css`
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;

    &:checked + ${RadioInputLabel} {
      border: 1px solid ${colors.primaryTouched};
    }

    &:focus + ${RadioInputLabel} {
      border: 1px solid ${colors.primaryTouched};
    }

    &:hover + ${RadioInputLabel} {
      border: 1px solid ${colors.primaryTouched};
      cursor: pointer;
    }
  `
};

export const RadioInput = styled.input.attrs({
  type: "radio"
})`
  ${withThemeStyles(radioInputThemeStyles)}
`;

const textInputThemeStyles = {
  [RADIO_INPUT_GROUP_THEMES.button]: css`
    border: 1px solid ${colors.foxGrey};
    margin: 0 0 20px;
    padding: 12px 20px;
    width: 100%;

    &:focus,
    &:active {
      border: 1px solid ${colors.primaryTouched};
    }
  `
};

export const HiddenLabel = styled.label`
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const TextInput = styled.input.attrs({
  type: "text"
})`
  ${withThemeStyles(textInputThemeStyles)}
`;
